// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__ybov6","buttons":"Footer_buttons__3yJwa"};